import { bindDialog, usePopupState } from 'material-ui-popup-state/hooks';
import React from 'react';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { ActionButton } from './ActionButton';
import { postFeaturesAssignRemove } from './api';
import styles from './ManageFeatures.module.css';
import { ToggleFeatureForm } from './ToggleFeatureForm';
import { ManageFeatureDialog } from './ManageFeatureDialog';
import type { FeatureAction } from './useFeatureActionForm';
import type { ToggleFeatureFields } from './useToggleFeatureForm';
import { useToggleFeatureForm } from './useToggleFeatureForm';

const action: FeatureAction<ToggleFeatureFields> = ({
  feature,
  entity,
  identifiers,
}) =>
  postFeaturesAssignRemove({
    entity,
    entityIds: identifiers,
    feature,
  });

type DisableFeatureProps = {
  feature: string;
};

export const DisableFeature = ({
  feature,
}: DisableFeatureProps): JSX.Element => {
  const popupState = usePopupState({
    variant: 'dialog',
    popupId: 'disable-feature',
  });
  const [form, handleSubmit] = useToggleFeatureForm({
    action,
    feature,
    close: popupState.close,
  });

  return (
    <>
      <ActionButton
        action={popupState.open}
        Icon={HighlightOffIcon}
        title="Disable (per entity)"
        busyMessage={`Disabling feature ${feature}`}
      />

      <ManageFeatureDialog
        title={
          <>
            Disable feature:{' '}
            <span className={styles.featureName}>{feature}</span>
          </>
        }
        onSubmit={handleSubmit}
        {...bindDialog(popupState)}
      >
        <ToggleFeatureForm mode="disable" feature={feature} form={form} />
      </ManageFeatureDialog>
    </>
  );
};
